import type { Topic } from "@/types";

export const topics: Topic[] = [
  {
    id: "featured-drama",
    title: "精选高分剧集",
    cover: "https://readdy.ai/api/search-image?query=dramatic%20cinematic%20film%20strip%20collage%20with%20moody%20lighting%2C%20cinematic%20poster%20art%2C%20navy%20teal%20palette%2C%20warm%20orange%20accent%20light%2C%20stylized%20painterly%20illustration%2C%20high%20detail%2C%20wide%20composition&width=1000&height=560&seq=jingpin-topic-1&orientation=landscape",
    intro: "评分与口碑双重认证的高分剧集合集，从悬疑到温情，一次看个够。",
    videoIds: ["v001", "v002", "v004", "v005", "v006"],
  },
  {
    id: "weekend-comedy",
    title: "周末解压喜剧",
    cover: "https://readdy.ai/api/search-image?query=playful%20colorful%20comedy%20stage%20scene%20with%20confetti%20and%20lights%2C%20cinematic%20poster%20art%2C%20navy%20teal%20palette%2C%20warm%20orange%20accent%20light%2C%20stylized%20painterly%20illustration%2C%20high%20detail%2C%20wide%20composition&width=1000&height=560&seq=jingpin-topic-2&orientation=landscape",
    intro: "忙碌一周后最需要的快乐充电站，用笑声扫走所有疲惫。",
    videoIds: ["v010", "v007", "v009", "v008"],
  },
  {
    id: "original-picks",
    title: "原创短片精选",
    cover: "https://readdy.ai/api/search-image?query=artistic%20indie%20film%20scene%20with%20warm%20nostalgic%20tones%2C%20cinematic%20poster%20art%2C%20navy%20teal%20palette%2C%20warm%20orange%20accent%20light%2C%20stylized%20painterly%20illustration%2C%20high%20detail%2C%20wide%20composition&width=1000&height=560&seq=jingpin-topic-3&orientation=landscape",
    intro: "平台自制原创内容合集，短小精悍却有温度，适合碎片时间观看。",
    videoIds: ["v012", "v013", "v015", "v014", "v016"],
  },
  {
    id: "nature-humanity",
    title: "自然与人文纪录",
    cover: "https://readdy.ai/api/search-image?query=sweeping%20natural%20landscape%20documentary%20scene%20with%20mountains%20and%20river%2C%20cinematic%20poster%20art%2C%20navy%20teal%20palette%2C%20warm%20orange%20accent%20light%2C%20stylized%20painterly%20illustration%2C%20high%20detail%2C%20wide%20composition&width=1000&height=560&seq=jingpin-topic-4&orientation=landscape",
    intro: "从深海到高山，从古老匠艺到城市脉络，看见世界的辽阔与温度。",
    videoIds: ["v021", "v022", "v023", "v024"],
  },
];